import type { ComponentPropsWithoutRef, ElementType } from 'react';
import { cx } from '../../utils/cx';
import s from './Text.module.css';

export type TextSize = 'bodyLg' | 'body' | 'bodySm' | 'label' | 'caption';
/** Every tone meets 4.5:1 on surfaces. (fg.subtle is intentionally not a text tone: it's for icons and decoration.) */
export type TextTone = 'default' | 'muted' | 'accent' | 'danger' | 'success' | 'link';

export type TextProps = ComponentPropsWithoutRef<'p'> & {
  as?: ElementType;
  size?: TextSize;
  tone?: TextTone;
  weight?: 'regular' | 'semibold' | 'bold' | 'extrabold';
  /** Clamp to N lines with an ellipsis. */
  lines?: 1 | 2 | 3;
};

export function Text({
  as: Tag = 'p',
  size = 'body',
  tone = 'default',
  weight,
  lines,
  className,
  style,
  ...rest
}: TextProps) {
  return (
    <Tag
      className={cx(s.text, className)}
      data-size={size}
      data-tone={tone}
      data-weight={weight}
      data-lines={lines}
      style={lines ? { ...style, WebkitLineClamp: lines } : style}
      {...rest}
    />
  );
}
